import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex1 display-flex justify-content-between info-title-havbutton-bottom" }
const _hoisted_2 = { class: "info-light-title" }
const _hoisted_3 = { class: "info-label-title vertical-align-top" }
const _hoisted_4 = { class: "info-label-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_apartment_edit_dialog = _resolveComponent("apartment-edit-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextBasicInformation), 1),
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.edit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.RDeiviceEdit), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.basicInformationData, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "info-item info-item-bottom",
        key: item.name
      }, [
        _createVNode("label", _hoisted_3, _toDisplayString(item.label), 1),
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.filterEmptyCellValue(item.value)), 1)
      ]))
    }), 128)),
    (_ctx.isShowApartmentEditDialog)
      ? (_openBlock(), _createBlock(_component_apartment_edit_dialog, {
          key: 0,
          onSuccess: _ctx.success,
          "init-form": _ctx.initForm,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowApartmentEditDialog=false))
        }, null, 8, ["onSuccess", "init-form"]))
      : _createCommentVNode("", true)
  ]))
}